var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientgradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15.83 12.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.87,
    y1: 3.06,
    x2: 10.96,
    y2: 3.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3aecfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4564ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.25,
    y1: 10.01,
    x2: 12.59,
    y2: 10.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 11.37,
    y1: 3.47,
    x2: 14.21,
    y2: 3.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 12.99,
    y1: 9.6,
    x2: 15.83,
    y2: 9.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.62,
    y1: 3.47,
    x2: 4.47,
    y2: 3.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    y1: 9.6,
    x2: 2.84,
    y2: 9.6,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M7.92,1.23c-1.01,0-1.83.82-1.83,1.84s.82,1.84,1.83,1.84,1.83-.82,1.83-1.84-.82-1.84-1.83-1.84ZM4.87,3.06c0-1.69,1.36-3.06,3.04-3.06s3.04,1.37,3.04,3.06-1.36,3.06-3.04,3.06-3.04-1.37-3.04-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.72,8.58c-1.24,0-2.25,1.01-2.25,2.26,0,.02,0,.04,0,.06,0,0,0,0,0,0,.33.18,1.25.53,3.44.53s3.12-.35,3.45-.53c0,0,0,0,0,0,0-.01,0-.03,0-.06,0-1.25-1.01-2.26-2.25-2.26h-2.4ZM3.25,10.84c0-1.93,1.55-3.49,3.47-3.49h2.4c1.92,0,3.47,1.56,3.47,3.49,0,.34-.12.83-.58,1.1-.56.33-1.71.72-4.09.72s-3.53-.39-4.09-.72c-.46-.27-.58-.76-.58-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.59,1.27c.09-.33.42-.52.75-.43,1.11.3,1.87,1.4,1.87,2.63,0,1.3-.89,2.5-2.16,2.65-.33.04-.64-.2-.68-.54s.2-.64.53-.68c.56-.07,1.09-.64,1.09-1.43s-.46-1.31-.97-1.45c-.32-.09-.52-.42-.43-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13,7.85c.06-.33.38-.55.71-.48,1.23.24,2.12,1.33,2.12,2.59v.33c0,.31-.09.79-.53,1.07-.27.18-.69.36-1.31.48-.33.07-.65-.15-.72-.48-.07-.33.15-.66.48-.72.46-.09.73-.21.86-.29h0s0-.04,0-.06v-.33c0-.67-.47-1.25-1.13-1.38-.33-.06-.55-.39-.48-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.24,5.68c-.09.33-.42.52-.75.43-1.11-.3-1.87-1.4-1.87-2.63,0-1.3.89-2.5,2.16-2.65.33-.04.64.2.68.54.04.34-.2.64-.53.68-.56.07-1.09.64-1.09,1.43s.46,1.31.97,1.45c.32.09.52.42.43.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2.83,7.85c-.06-.33-.38-.55-.71-.48-1.23.24-2.12,1.33-2.12,2.59v.33c0,.31.09.79.53,1.07.27.18.69.36,1.31.48.33.07.65-.15.72-.48.07-.33-.15-.66-.48-.72-.46-.09-.73-.21-.86-.29h0s0-.04,0-.06v-.33c0-.67.47-1.25,1.13-1.38.33-.06.55-.39.48-.72Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientgradient);
export default __webpack_public_path__ + "static/media/Client gradient.2d1279c6d01de62ec6d9c649fa4ce5d4.svg";
export { ForwardRef as ReactComponent };